<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm ts-uppercase">{{ $t('payMonthlyDeduction.importUnpaidLeave') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-loading-banner :loading="loadingPreData">
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="ts-flex">
            <div class="ts-flex">
              <label class="col-sm-4 control-label"> {{ $t('payMonthlyDeduction.year') }}</label>
              <div>
                <ts-date-picker-input
                  :class="{ 'is-invalid': errors.has('cycle_year') }"
                  format="YYYY"
                  v-model="model.cycle_year"
                ></ts-date-picker-input>
              </div>
              <div class="invalid-feedback" v-if="errors.has('cycle_year')">
                {{ errors.first('cycle_year') }}
              </div>
            </div>
            <div class="ts-flex">
              <label class="col-sm-4 control-label"> {{ $t('payMonthlyDeduction.month') }}</label>
              <div>
                <ts-date-picker-input
                  :class="{ 'is-invalid': errors.has('cycle_month') }"
                  format="MM"
                  v-model="model.cycle_month"
                ></ts-date-picker-input>
              </div>
              <div class="invalid-feedback" v-if="errors.has('cycle_month')">
                {{ errors.first('cycle_month') }}
              </div>
            </div>
            <div class="ts-flex-grow"></div>
            <ts-button
              class="btn-primary mr-2"
              @click.prevent="generate"
              :waiting="saving"
              :disabled="model.selectedLeaveRecords.length <= 0"
            >
              {{ $t('button.generate') }}
            </ts-button>
          </div>
        </form>
      </ts-card-wrapper>
      <div class="menu-container">
        <div class="leave-record-table-container">
          <ts-card-wrapper>
            <div class="d-flex justify-content-end">
              <ts-input v-model="searchText" :placeholder="$t('search')" />
            </div>
          </ts-card-wrapper>
          <table class="table table-hover ui-table ts-table" v-if="availableLeaveRecords.length > 0">
            <thead>
              <tr>
                <th class="with-checkbox ui-checkable">
                  <ts-checkbox v-model="checkAll" @change="selectAll">
                    All
                  </ts-checkbox>
                </th>
                <th>{{ $t('payMonthlyDeduction.photo') }}</th>
                <th class="text-center">{{ $t('payMonthlyDeduction.employeeId') }}</th>
                <th>{{ $t('payMonthlyDeduction.employeeName') }}</th>
                <th class="text-center">{{ $t('payMonthlyDeduction.dateFrom') }}</th>
                <th class="text-center">{{ $t('payMonthlyDeduction.timeFrom') }}</th>
                <th class="text-center">{{ $t('payMonthlyDeduction.dateTo') }}</th>
                <th class="text-center">{{ $t('payMonthlyDeduction.timeTo') }}</th>
                <th>{{ $t('payMonthlyDeduction.leaveType') }}</th>
                <th class="text-center">{{ $t('payMonthlyDeduction.total') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in availableLeaveRecords" :key="index">
                <td class="with-checkbox ui-checkable">
                  <ts-checkbox :value="record.lr_id" v-model="model.selectedLeaveRecords"> </ts-checkbox>
                </td>
                <td class="with-img">
                  <img class="height-30 ts-rounded" :src="photoEmp(record)" @error="onError(record)" />
                </td>
                <td class="text-center ts-whitespace-no-wrap">{{ record.employee ? record.employee.card_id : '' }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.employee ? record.employee.employee_name_en + '|' + record.employee.employee_name_kh : '' }}
                </td>
                <td class="text-center ts-whitespace-no-wrap">{{ record.date_from }}</td>
                <td class="text-center ts-whitespace-no-wrap">{{ record.time_from_show }}</td>
                <td class="text-center ts-whitespace-no-wrap">{{ record.date_to }}</td>
                <td class="text-center ts-whitespace-no-wrap">{{ record.time_to_show }}</td>
                <td class="ts-whitespace-no-wrap">{{ record.leave_type_name }}</td>
                <td class="text-center ts-whitespace-no-wrap">{{ record.total_day_show }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="availableLeaveRecords.length <= 0" class="text-center mt-5">
            {{ $t('payMonthlyDeduction.noFoundRecord') }}
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'import-leave-record-form',
  props: ['data'],
  data() {
    return {
      model: {
        deduction_id: '',
        cycle_year: moment().format('YYYY'),
        cycle_month: moment().format('MM'),
        selectedLeaveRecords: []
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false,
      searchText: '',
      manPhoto: require('../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../assets/staff-default-women.png')
    }
  },
  computed: {
    ...mapState('hr/payMonthlyDeduction', ['leaveRecords']),

    availableLeaveRecords() {
      return this.leaveRecords.filter(lr => {
        if (this.searchText.trim() !== '') {
          return (
            lr.date_from.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            lr.date_to.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            lr.time_from.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            lr.time_to.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            lr.employee.card_id.includes(this.searchText.toLowerCase().trim()) ||
            lr.employee.employee_name_en.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            lr.employee.employee_name_kh.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            lr.leave_type.leave_type_en.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            lr.leave_type.leave_type_en.toLowerCase().includes(this.searchText.toLowerCase().trim())
          )
        }

        return this.leaveRecords
      })
    },
    checkAll() {
      return this.model.selectedLeaveRecords.length == this.leaveRecords.length
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.model.deduction_id = this.data.deduction_id
      this.$store.commit('hr/payMonthlyDeduction/RECEIVE_LEAVE_RECORDS', [])
      this.loadingPreData = true
      this.$store
        .dispatch('hr/payMonthlyDeduction/fetchLeaveRecord', { item_type_id: this.data.item_custom_rule.item_type_id })
        .then(() => {
          this.loadingPreData = false
          this.autoSelectAll()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    photoEmp(record) {
      if (record.employee.photo) {
        return record.employee.photo + '&api_token=' + this.$store.getters.accessToken
      }

      return record.employee.sex == 'Male' ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event.target.src = record.employee.sex == 'Male' ? this.manPhoto : this.womenPhoto
    },
    selectAll(e) {
      if (e) {
        this.model.selectedLeaveRecords = []
        this.$nextTick(() => {
          this.leaveRecords.map(el => {
            this.model.selectedLeaveRecords.push(el.lr_id)
          })
        })
      } else {
        this.model.selectedLeaveRecords = []
      }
    },
    autoSelectAll() {
      this.model.selectedLeaveRecords = []
      this.$nextTick(() => {
        this.leaveRecords.map(el => {
          this.model.selectedLeaveRecords.push(el.lr_id)
        })
      })
    },
    async generate() {
      this.errors = new Errors()
      this.saving = true

      try {
        let response = await this.$store.dispatch('hr/payMonthlyDeduction/generate', this.model)

        return this.$store.dispatch('hr/payMonthlyDeduction/fetch').then(res => {
          this.saving = false
          this.$emit('close')
          this.$toasted.success(response.message)
          return Promise.resolve(res)
        })
      } catch (error) {
        this.$toasted.error(error.message)
        this.errors = new Errors(error.errors)
      }

      this.saving = false
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-container {
  height: 50vh;
  overflow-y: scroll;
  overflow-x: scroll;
}
.leave-record-table-container {
  height: 48vh;

  .table > thead > tr > th {
    position: sticky;
    top: 0;
    background: rgba(230, 230, 230, 1);
    z-index: 10;
  }
  table th,
  td {
    padding: 10px 15px;
    vertical-align: middle !important;
    white-space: nowrap;
  }
}
::-webkit-scrollbar {
  height: 10px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #dee0e0;
}
div::-webkit-scrollbar-thumb:hover {
  background: #bebfc0;
}
</style>
